/**
 * Next Notification Text from an SSE fancy frame (pre-#33 / pin-prev era).
 * Applies when `notification` is present and non-null; otherwise keeps current.
 * Empty string clears the field; omitted/null leaves the open scoreboard value.
 */
export function nextNotificationFromSocket(
  current: string | null | undefined,
  data: Record<string, unknown>,
): string {
  const cur = current == null ? '' : String(current)
  return data.notification != null ? String(data.notification) : cur
}
